import { render, staticRenderFns } from "./tiaojia_detail.vue?vue&type=template&id=4e24d288&scoped=true"
import script from "./tiaojia_detail.vue?vue&type=script&lang=js"
export * from "./tiaojia_detail.vue?vue&type=script&lang=js"
import style0 from "./tiaojia_detail.vue?vue&type=style&index=0&id=4e24d288&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e24d288",
  null
  
)

export default component.exports